import { ClbHeaderNotification, ClbLoading } from '@celebration/react'
import { FC, useCallback, useEffect } from 'react'
import { useNotificationHubApi } from '../hooks'

const poolingIntervalInMinutes: number = 5
const poolingIntervalInMilliseconds: number = poolingIntervalInMinutes * 60 * 1000

const Notifications: FC = () => {
  const { notifications, updateNotifications, isLoading } = useNotificationHubApi()

  const refreshNotifications = useCallback(() => {
    Promise.resolve(updateNotifications())
  }, [updateNotifications])

  useEffect(() => {
    refreshNotifications()

    const interval = setInterval(refreshNotifications, poolingIntervalInMilliseconds)

    return () => {
      clearInterval(interval)
    }
  }, [refreshNotifications])

  if (isLoading) return <ClbLoading aria-label='loading' size='sm' />

  return (
    <ClbHeaderNotification
      newNotification={notifications.length > 0}
      notifications={notifications.map(({ title, content }) => ({
        label: title,
        description: content,
      }))}
      onClickNotification={updateNotifications}
    />
  )
}
export default Notifications
